var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-article-tools"},[_c('action',{staticClass:"print",attrs:{"name":"link-light","with-icon":"mdi-printer","nochevron":true,"small":true},on:{"click":function($event){return _vm.printWindow()}}},[_vm._v(" Imprimer ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }